import React from "react"
import { Container, Row, Col, Button } from "react-bootstrap"
import Image from "@src/utils/image"
import Text from "@src/utils/text"
import { Link } from "gatsby"
import { BsArrowRight } from "react-icons/bs"

const Ebook = () => {
  return (
    <section className="bg-lipstick align-items-center py-4 py-md-5 ebook">
      <Container>
        <Row className=" align-items-center">
          <Col md={6} className="mb-3 mb-md-0">
            <Text id="1MWgInmMJlnjtVWBDHbgCE" />
            <Button
              variant="powder"
              as={Link}
              to="/product/shine-your-light-ebook"
            >
              Get the ebook! <BsArrowRight size="1.5em" />
            </Button>
          </Col>
          <Col md={6}>
            <Image id="5X9Vwx2XiMlkNEdTbyupA8" />
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default Ebook
